import { IconLoader, useLocalization } from '@magicdoorinc/ui';
import type { Component } from 'solid-js';

export const AccessGuardLoading: Component = () => {
  const { t } = useLocalization();

  return (
    <div class="flex h-full min-h-[600px] flex-col items-center justify-center p-8">
      <div class="flex max-w-md flex-col items-center text-center">
        <IconLoader class="mb-6 size-10 animate-spin text-text-02" />
        <p class="text-sm text-text-03">{t('Checking access...')}</p>
      </div>
    </div>
  );
};
